import React from 'react'

export default function SalaryBadge (props) {
  return (
    <span className='bg-primary-500 text-xs rounded px-1 text-white inline-block ml-1'>
      {props.children}
    </span>
  )
}
